export default {
    ValidationException: 'ValidationException',
};
